<template>
  <div class="first-login first-login-box">
    <van-dialog
      v-model="show"
      :confirm-button-text="lang.ok"
      confirm-button-color="#e50113"
    >
      <div class="content">
        <img
          class="img"
          src="../assets/gold_bg.png"
          alt
        >
        <p class="gold">
          {{ coinNum }}{{ lang.coin100 }}
        </p>
        <p class="p">
          {{ lang.welcome1 }}
        </p>
        <p class="fz-12">
          {{ coinNum }}{{ lang.welcome2 }}
        </p>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import lang from './../../common/language/index';
export default {
  name: 'Index',
  props: ['coinNum'],
  data() {
    return {
      lang: lang,
      show: false
    };
  },
  // created() {
  //   if (this.$route.query.isfirstlogin) this.show = true;
  // },
  mounted() {
    setTimeout(() => {
      if (this.pub.getCookie('isfirstlogin')) {
        if (window.location.href.indexOf('/login') == -1) {this.show = true;}
        this.pub.delCookie('isfirstlogin');
      }
    }, 1500);
  }
};
</script>

<style lang="scss" scoped>
.first-login {
  .content {
    padding: 24px 24px 12px;
    text-align: center;
    .gold {
      color: #fff;
      position: relative;
      top: -32px;
    }
    .p {
      line-height: 16px;
      margin-bottom: 6px;
    }
    .img {
      margin-bottom: 6px;
    }
    .fz-12 {
      font-size: 12px;
      line-height: 22px;
    }
  }
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
